export default "__VITE_ASSET__72LonSyw__"